<template>
    <div>
        <!-- Modal Form -->
        <div v-if="loader" id="loader-notification-div-vue">
            <h3 class="popover-title">{{ title }}</h3>
            <img
                v-if="loading"
                src="assets/ajax-loader.gif"
                style="padding: 10px;"
            />
            <div v-if="reportId" style="padding: 13px;">
                <a :href="'/view/report/' + reportId"> View Report</a>
            </div>
        </div>
        <lab-connection-error ref="labConnectionErrorModal" />
    </div>
</template>

<script>
import ScheduleHelper from "@/module/schedule/helper";
import LabConnectionError from "@/module/commons/lab-connection-error";
export default {
    name: "loaderNotification",
    components: { LabConnectionError },
    mixins: [ScheduleHelper, LabConnectionError],
    data() {
        return {
            loader: false,
            title: "",
            reportId: 0,
            loading: true
        };
    },
    computed: {},
    mounted() {
        let self = this;

        //-- show progress if triggered
        self._getSetting().then(setting => {
            let notificationStatus =
                "notification_status:" +
                self.$root.currentActor.id +
                ":" +
                setting.business_id;

            //-- check local storage
            let currentmessage = window.localStorage.getItem(
                notificationStatus
            );

            let generateReport =
                "generate-report:" +
                self.$root.currentActor.id +
                ":" +
                setting.business_id;

            if (currentmessage && currentmessage.length > 0) {
                self.loader = true;
                self.title = currentmessage;
            }

            self.$socket.$subscribe(notificationStatus, data => {
                self.socketNotificationResponse(data, notificationStatus);
            });

            self.$socket.$subscribe(
                "lab_request:" +
                    self.$root.currentActor.id +
                    ":" +
                    setting.business_id,
                message => {
                    let response = JSON.parse(message);
                    // if source has more than 1 providers, show UTILITY.message();
                    // confirm with Sagi
                    if (
                        response.connection_error &&
                        response.lab_connection_error.length > 0
                    ) {
                        // check total fail request
                        if (
                            response.lab_connection_error.length ===
                            response.lab_source.length
                        ) {
                            self.loader = false;
                            self.$refs["labConnectionErrorModal"].open(
                                response
                            );
                        }
                    }

                    if (
                        (response.lab_ids && response.lab_ids.length > 0) ||
                        response.idexx_lab_id
                    ) {
                        let print_lab_params = {
                            idexx_lab_id: response.idexx_lab_id,
                            idexx_url: response.idexx_url,
                            lab_ids: response.lab_ids,
                            source: response.lab_source,
                            connection_error: response.connection_error,
                            lab_connection_error: response.lab_connection_error,
                            module: "appointment"
                        };

                        self._print_lab_order(print_lab_params).then(
                            lab_response => {
                                let checkTtlService = setInterval(function () {
                                    if (!document.hidden) {
                                        clearInterval(checkTtlService);
                                        if (
                                            window.localStorage.getItem(
                                                "open_requisition_iframe"
                                            ) === null
                                        ) {
                                            if (lab_response.idexx_iframe) {
                                                // load idexx iframe
                                                lab_response.module_url =
                                                    print_lab_params.module_url;
                                                lab_response.module =
                                                    print_lab_params.module;
                                                lab_response[
                                                    "connection_error"
                                                ] =
                                                    print_lab_params.connection_error;
                                                lab_response[
                                                    "lab_connection_error"
                                                ] =
                                                    print_lab_params.lab_connection_error;

                                                self.$root.$emit(
                                                    "call_idexx_iframe",
                                                    lab_response
                                                );
                                                setTimeout(function () {
                                                    // close loader notification
                                                    window.localStorage.removeItem(
                                                        notificationStatus
                                                    );
                                                    self.loader = false;
                                                }, 2000);
                                            } else {
                                                // load requisition form modal
                                                lab_response.module_url =
                                                    print_lab_params.module_url;
                                                lab_response.module =
                                                    print_lab_params.module;
                                                lab_response[
                                                    "connection_error"
                                                ] =
                                                    print_lab_params.connection_error;
                                                lab_response[
                                                    "lab_connection_error"
                                                ] =
                                                    print_lab_params.lab_connection_error;

                                                self.$root.$emit(
                                                    "call-multirequsition-modal",
                                                    lab_response
                                                );
                                                window.localStorage.removeItem(
                                                    notificationStatus
                                                );
                                                self.loader = false;
                                            }
                                            window.localStorage.setItem(
                                                "open_requisition_iframe",
                                                1
                                            );
                                        } else if (
                                            window.localStorage.getItem(
                                                "open_requisition_iframe"
                                            ) == 1
                                        ) {
                                            self.loader = false;
                                        }
                                    }
                                }, 1000);
                            }
                        );
                    } else if (response.heska_sent_to_lab == true) {
                        window.localStorage.removeItem(notificationStatus);
                        self.loader = false;
                    } else if (
                        typeof response.idexx_error_msg !== "undefined" &&
                        response.idexx_error_msg != null &&
                        response.idexx_error_msg != ""
                    ) {
                        self._message(response.idexx_error_msg, "danger");
                        self.loader = false;
                    }
                }
            );

            self.$socket.$subscribe(generateReport, data => {
                let message = data;
                if (message && message.length > 0) {
                    if (message.indexOf("view_from_cache") !== -1) {
                        self.loader = false;
                        self.loading = true;
                        self.reportId = 0;
                    } else if (message.indexOf("ready") !== -1) {
                        self.loader = true;
                        self.loading = false;
                        let report = message.split("ReportId:");
                        self.reportId = report[1];
                        self.title = report[0];
                        if (this.$route.path == "/report/" + report[1]) {
                            location.reload();
                        }
                    } else {
                        self.loader = true;
                        self.title = message;
                    }
                }
            });
        });
    },
    methods: {
        socketNotificationResponse(message, notificationStatus) {
            let self = this;
            if (message && message.length > 0) {
                switch (message) {
                    case "reminder_bundle_close_success":
                        window.localStorage.removeItem(notificationStatus);
                        self.loader = false;
                        break;
                    case "reminder_bundle_close_error":
                        self._message(
                            "Error saving reminders. Please try again.",
                            "danger"
                        );
                        window.localStorage.removeItem(notificationStatus);
                        self.loader = false;
                        break;

                    default:
                        window.localStorage.removeItem(
                            "open_requisition_iframe"
                        );

                        self.loader = true;
                        self.title = message;
                        break;
                }
            }
        }
    }
};
</script>
<style lang="scss">
#loader-notification-div-vue {
    z-index: 100;
    background-color: #d9edf7;
    border-color: #fff;
    border: 1px solid #ccc;
    position: fixed;
    bottom: 0;
    right: 0;
    width: 250px;
    height: 80px;
    margin-right: 10px;
    margin-bottom: 10px;
    white-space: normal;
    background-color: #ffffff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, 0.2);
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    -webkit-background-clip: padding-box;
    -moz-background-clip: padding;
    background-clip: padding-box;
}

#loader-notification-div-vue .popover-title {
    padding: 8px 14px;
    margin: 0;
    font-size: 12px;
    font-weight: bold;
    line-height: 18px;
    background-color: #f7f7f7;
    border-bottom: 1px solid #ebebeb;
    -webkit-border-radius: 5px 5px 0 0;
    -moz-border-radius: 5px 5px 0 0;
    border-radius: 5px 5px 0 0;
}
</style>
